
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.167 18.104L3.333 14.75a1.624 1.624 0 01-.833-1.438V6.689a1.623 1.623 0 01.833-1.438l5.834-3.354c.264-.153.541-.23.833-.23.292 0 .57.077.833.23l5.834 3.354a1.624 1.624 0 01.833 1.438v6.625a1.624 1.624 0 01-.833 1.437l-5.834 3.354c-.264.153-.541.23-.833.23-.292 0-.57-.077-.833-.23zm0-7.625v5.709l.833.479.833-.48V10.48l5-2.896v-.875l-.896-.52L10 9.042 5.062 6.188l-.895.52v.875l5 2.896z"}})])
          )
        }
      }
    